import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage, useIntl} from "react-intl";

import {
    Box,
    Table,
    TableBody,
    TableHead,
} from "@mui/material";

import {greyishBlue500} from "assets/jss/main";

import ProductRow from "./ProductRow";
import TopTableHeader from "../../TopTablesComponents/TopTableHeader";
import TopTableLoader from "../../TopTablesComponents/TopTableLoader";
import RankHeaderLabel from "../../TopTablesComponents/RankHeaderLabel";

function TopProductsTable({ data, loading }) {
    const intl = useIntl();

    if (loading) {
        return <TopTableLoader />
    }

    if (!data?.lineItems?.length) {
        return (
            <div style={{ color: greyishBlue500, fontSize: "14px", padding: "32px 0", textAlign: "center" }}>
                <FormattedMessage id="dashboard.productsRanking.table.no_result" />
            </div>
        );
    }

    const headers = [
        { label: <RankHeaderLabel>{intl.formatMessage({ id: "dashboard.table.header.rank" })}</RankHeaderLabel>, align: "left" },
        { label: <FormattedMessage id="dashboard.topProducts.table.header.sales" />, align: "left" },
        { label: <FormattedMessage id="dashboard.productRank.table.header.stock" />, align: "left" },
        { label: <FormattedMessage id="dashboard.topProducts.table.header.variants" />, align: "left" },
        { label: <FormattedMessage id="dashboard.topProducts.table.header.reference" />, align: "left" },
    ];

    return (
        <Box sx={{ overflowX: "auto" }}>
            <Table size="small" sx={{ minWidth: 500 }}>
                <TableHead>
                    <TopTableHeader headers={headers} />
                </TableHead>
                <TableBody>
                    {data.lineItems.map((product, index) => (
                        <ProductRow
                            key={product.id ?? index}
                            rank={index + 1}
                            product={product}
                        />
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
}

TopProductsTable.propTypes = {
    data: PropTypes.object,
    loading: PropTypes.bool,
};

export default TopProductsTable;
